<template>
    <div>
        <div class="text-xl" style="opacity: .9;">
            <integration-icon class="mr-1" style="color: inherit;" :integration="order.integration"/>
            {{ order.integration_order_id }}
        </div>
        <div class="mt-1">
            <div class="font-weight-bold text-lg">
                {{ store.attributes.name }}
            </div>
            <store-address :store="store"/>
        </div>
    </div>
</template>

<script>
import OrderTypeIcon from './OrderTypeIcon'
import OrderStateIcon from './OrderStateIcon'
import IntegrationIcon from '@components/Integrations/IntegrationIcon'
import DateTime from '@components/DateTime'
import StoreAddress from '@components/Store/StoreAddress.vue'

export default {
    components: {
        StoreAddress,
        OrderTypeIcon,
        OrderStateIcon,
        DateTime,
        IntegrationIcon,
    },

    props: {
        order: Object,
        store: Object,
    },
}
</script>
